let config;

switch (process.env.NODE_ENV) {
  case 'production':
    config = require('./config.production.json');
    break;
  case 'staging':
    config = require('./config.staging.json');
    break;
  default:
    config = require('./config.development.json');
}

export default config;
